import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Routes } from './appRoutes';
import ProtectRoute from './protectRoute';
import NonAuthRoute from './nonAuthRoute';
import {
  Login,
  Forget_Password,
  SignUp,
  OTP_Verify,
  CustomerLogin,
} from '../pages/non-auth/index';
import AreaChart from '../pages/auth/chart/chart';
import {
  Role_Management,
  EditRole,
  CreateRole,
  AuditLog,
  UserManagement,
  CreateUser,
  AuditLogUpdate,
  Inventory,
  EquipmentList,
  OwnedEquipmentDetails,
  sharedWithMeEquipmentsDetails,
  Payment,
  ManageBilling,
  ProfileManagement,
  ShareEquipments,
} from '../pages/auth';
import Alert from '../pages/auth/alert';

const Routers = createBrowserRouter([
  {
    path: Routes.emptyPath,
    element: (
      <Navigate to={Routes.OwnedEquipments.path} {...Routes.OwnedEquipments} />
    ),
  },
  {
    path: Routes.login.path,
    element: <NonAuthRoute component={Login} {...Routes.login} />,
  },
  {
    path: Routes.customerLogin.path,
    element: (
      <NonAuthRoute component={CustomerLogin} {...Routes.customerLogin} />
    ),
  },
  {
    path: Routes.signup.path,
    element: <NonAuthRoute component={SignUp} {...Routes.signup} />,
  },
  {
    path: Routes.forgotPassword.path,
    element: (
      <NonAuthRoute component={Forget_Password} {...Routes.forgotPassword} />
    ),
  },
  {
    path: Routes.otpVerify.path,
    element: <NonAuthRoute component={OTP_Verify} {...Routes.otpVerify} />,
  },
  {
    path: Routes.roleManagement.path,
    element: (
      <ProtectRoute component={Role_Management} {...Routes.roleManagement} />
    ),
  },
  {
    path: Routes.createRole.path,
    element: <ProtectRoute component={CreateRole} {...Routes.createRole} />,
  },
  {
    path: Routes.editRole.path,
    element: <ProtectRoute component={EditRole} {...Routes.editRole} />,
  },

  {
    path: Routes.userManagement.path,
    element: (
      <ProtectRoute component={UserManagement} {...Routes.userManagement} />
    ),
  },
  {
    path: Routes.createUser.path,
    element: <ProtectRoute component={CreateUser} {...Routes.createUser} />,
  },
  {
    path: Routes.editUser.path,
    element: <ProtectRoute component={CreateUser} {...Routes.editUser} />,
  },

  {
    path: Routes.auditLog.path,
    element: <ProtectRoute component={AuditLog} {...Routes.auditLog} />,
  },
  {
    path: Routes.auditLogUpdate.path,
    element: (
      <ProtectRoute component={AuditLogUpdate} {...Routes.auditLogUpdate} />
    ),
  },
  {
    path: Routes.editProfile.path,
    element: (
      <ProtectRoute component={AuditLogUpdate} {...Routes.editProfile} />
    ),
  },
  {
    path: Routes.Inventory.path,
    element: <ProtectRoute component={Inventory} {...Routes.Inventory} />,
  },
  {
    path: Routes.PersonalDetails.path,
    element: (
      <ProtectRoute component={ProfileManagement} {...Routes.PersonalDetails} />
    ),
  },
  {
    path: Routes.OrganizationDetails.path,
    element: (
      <ProtectRoute
        component={ProfileManagement}
        {...Routes.OrganizationDetails}
      />
    ),
  },
  {
    path: Routes.NotificatiopnPreference.path,
    element: (
      <ProtectRoute
        component={ProfileManagement}
        {...Routes.NotificatiopnPreference}
      />
    ),
  },
  {
    path: Routes.OwnedEquipments.path,
    element: (
      <ProtectRoute component={EquipmentList} {...Routes.OwnedEquipments} />
    ),
  },
  {
    path: Routes.sharedWithMeEquipments.path,
    element: (
      <ProtectRoute
        component={EquipmentList}
        {...Routes.sharedWithMeEquipments}
      />
    ),
  },
  {
    path: Routes.sharedWithMeEquipmentsDetails.path,
    element: (
      <ProtectRoute
        component={sharedWithMeEquipmentsDetails}
        {...Routes.sharedWithMeEquipmentsDetails}
      />
    ),
  },
  {
    path: Routes.OwnedEquipmentsDetails.path,
    element: (
      <ProtectRoute
        component={OwnedEquipmentDetails}
        {...Routes.OwnedEquipmentsDetails}
      />
    ),
  },
  {
    path: '/payment',
    element: <Payment />,
  },
  {
    path: Routes.manageBilling.path,
    element: (
      <ProtectRoute component={ManageBilling} {...Routes.manageBilling} />
    ),
  },
  {
    path: Routes.shareEquipments.path,
    element: (
      <ProtectRoute component={ShareEquipments} {...Routes.shareEquipments} />
    ),
  },
  {
    path: Routes.shareOwnedEquipments.path,
    element: (
      <ProtectRoute
        component={ShareEquipments}
        {...Routes.shareOwnedEquipments}
      />
    ),
  },
  {
    path: '/areaChart',
    element: <ProtectRoute component={AreaChart} />,
  },
  {
    path: Routes.alert.path,
    element: <ProtectRoute component={Alert} {...Routes.alert} />,
  },
]);

export default Routers;
